import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    eventoId: 0,
    importParticipantesId: 0,
    participanteId: 0,

    evento: {},
    participante: {},
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, params) {
        state.eventoId = parseInt(params.eventoId);
        state.importParticipantesId = parseInt(params.importParticipantesId);
        state.participanteId = parseInt(params.participanteId);

        state.evento = {};

        state.participante = {
            /* Datos del participante */
            nombreCompleto: null,
            fechaNacimiento: null,
            documentoNumero: null,
            sexo: null,
            pais: null,
            provincia: null,
            localidad: null,
            direccion: null,
            codigoPostal: null,
            numeroCelular: null,
            email: null,
            clientePrevio: 'No',
            numeroCliente: null,
            observaciones: null,
            
            /* Codigo promocion */
            codigoPromocion: null,
            
            /* Datos Bancarios */
            banco: null,
            cbu: null,
            cbuAlias: null,
            titularCuenta: null,
            titularCuit: null,

            // /* Negocio */
            // negocio: {
            //     posicion: null,
            //     nombreComercial: null,
            //     razonSocial: null,
            //     cuit: null,
            //     pais: null,
            //     provincia: null,
            //     localidad: null,
            //     barrio: null,
            //     direccion: null,
            //     codigoPostal: null
            // },

            posicionSorteo: 0,

            camposAdicionales: []
        };
    },
    'SET_EVENTO' (state, evento) {
        state.evento = evento;
    },
    'SET_DATOS' (state, participante) {
        state.participante = {
            /* Datos del participante */
            nombreCompleto: participante.nombreCompleto,
            fechaNacimiento: participante.fechaNacimiento,
            documentoNumero: participante.documentoNumero,
            sexo: participante.sexo,
            pais: participante.pais,
            provincia: participante.provincia,
            localidad: participante.localidad,
            direccion: participante.direccion,
            codigoPostal: participante.codigoPostal,
            numeroCelular: participante.numeroCelular,
            email: participante.email,
            
            /* Codigo promocion */
            codigoPromocion: participante.codigoPromocion,
            
            /* Datos Bancarios */
            banco: participante.banco,
            cbu: participante.cbu,
            cbuAlias: participante.cbuAlias,
            titularCuenta: participante.titularCuenta,
            titularCuit: participante.titularCuit,

            // /* Negocio */
            // negocio: {
            //     posicion: participante.negocio? participante.negocio.posicion : null,
            //     nombreComercial: participante.negocio? participante.negocio.nombreComercial : null,
            //     razonSocial: participante.negocio? participante.negocio.razonSocial : null,
            //     cuit: participante.negocio? participante.negocio.cuit : null,
            //     pais: participante.negocio? participante.negocio.pais : null,
            //     provincia: participante.negocio? participante.negocio.provincia : null,
            //     localidad: participante.negocio? participante.negocio.localidad : null,
            //     barrio: participante.negocio? participante.negocio.barrio : null,
            //     direccion: participante.negocio? participante.negocio.direccion : null,
            //     codigoPostal: participante.negocio? participante.negocio.codigoPostal : null
            // },

            posicionSorteo: participante.posicionSorteo,

            camposAdicionales: participante.camposAdicionales
        };
    },
};

const getters = {
    getField,
};

const actions = {
    getDatos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);

            /* Recuperamos los datos del evento (configuración) */
            apiAxios.get(`eventos/${params.eventoId}`) 
                .then(res => {
                    commit('SET_EVENTO', res.data);

                    /* Recuperamos los datos del participante */
                    return apiAxios.get(`eventos/${params.eventoId}/import-participantes/${params.importParticipantesId}/participantes/${params.participanteId}`);
                })
                .then(res => {
                    commit('SET_DATOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}